document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('variant-option')) return;

  const card = e.target.closest('.card__content');
  if (!card) return;

  const priceWrap = card.querySelector('[data-card-price] .price');
  if (!priceWrap) return;

  const variantsEl = card.querySelector('.variants_d');
  if (!variantsEl) return;

  let variants;
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch {
    return;
  }

  const selectedOptions = Array.from(
    card.querySelectorAll('.variant-option')
  ).map(el => el.value);

  const variant = variants.find(v =>
    v.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!variant) return;

  const regularSpan = priceWrap.querySelector(
    '.price__regular .price-item--regular'
  );
  const compareSpan = priceWrap.querySelector(
    '.price__sale s.price-item--regular'
  );
  const saleSpan = priceWrap.querySelector(
    '.price__sale .price-item--sale'
  );

  const format = window.Shopify?.formatMoney || function (cents) {
    return '₹. ' + (cents / 100).toFixed(2);
  };

  // ON SALE
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    priceWrap.classList.add('price--on-sale');

    if (regularSpan)
      regularSpan.textContent = format(variant.compare_at_price);

    if (compareSpan)
      compareSpan.textContent = format(variant.compare_at_price);

    if (saleSpan)
      saleSpan.textContent = format(variant.price);
  }
  // NOT ON SALE
  else {
    priceWrap.classList.remove('price--on-sale');

    if (regularSpan)
      regularSpan.textContent = format(variant.price);

    if (compareSpan) compareSpan.textContent = '';
    if (saleSpan) saleSpan.textContent = '';
  }
});
